import { useDashboardContext } from 'Views/Dashboard/DashboardContext';

export default function useNavigationDrawer() {
  const { handleNavigateToSurvey } = useDashboardContext();

  const handleClickCard = (onboardingStepResourceLink) => {
    return handleNavigateToSurvey(onboardingStepResourceLink);
  };

  return {
    handleClickCard,
  };
}
